import { createPublicClient, http } from 'viem'
import { bsc, bscTestnet } from 'viem/chains'
import Web3 from 'web3'

export const publicClient = createPublicClient({
    chain: bsc,
    transport: http()
})

const PROVIDER_URL_BSC = 'https://bsc-dataseed.binance.org/'
const PROVIDER_URL_SEP = 'https://sepolia.gateway.tenderly.co'
const PROVIDER_URL_BASE = 'https://mainnet.base.org'
const PROVIDER_URL_POL = 'https://polygon.llamarpc.com'
const PROVIDER_URL_ETH = 'https://ethereum-rpc.publicnode.com'
const PROVIDER_URL_TAO = 'https://rpc.taoevm.io'

// Multiple BSC Testnet RPC endpoints for better reliability
const PROVIDER_URL_BSCTEST_OPTIONS = [
  'https://data-seed-prebsc-1-s1.binance.org:8545/',
  'https://data-seed-prebsc-2-s1.binance.org:8545/',
  'https://data-seed-prebsc-1-s2.binance.org:8545/',
  'https://data-seed-prebsc-2-s2.binance.org:8545/',
  'https://bsc-testnet.public.blastapi.io',
  'https://bsc-testnet-rpc.publicnode.com'
]

/** BSC Testnet (chain id 97) — for read-only helpers alongside wagmi `bscTestnet`. */
export const publicClientBscTestnet = createPublicClient({
    chain: bscTestnet,
    transport: http(PROVIDER_URL_BSCTEST_OPTIONS[0])
})

// Helper function to create Web3 client with fallback RPCs
const createWeb3ClientWithFallback = (rpcUrls: string[]) => {
  // Try the first RPC, if it fails, the application can handle errors
  // For now, we'll use the first one as primary
  return new Web3(new Web3.providers.HttpProvider(rpcUrls[0]))
}

export const web3ClientBsc = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_BSC))
export const web3ClientSep = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_SEP))
export const web3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_ETH))
export const baseWeb3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_BASE))
export const polWeb3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_POL))
export const taoWeb3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_TAO))
export const web3ClientBscTest = createWeb3ClientWithFallback(PROVIDER_URL_BSCTEST_OPTIONS)

// Export the BSC testnet RPC options for use elsewhere if needed
export const BSC_TESTNET_RPC_OPTIONS = PROVIDER_URL_BSCTEST_OPTIONS

export const web3Clients = {
    56: web3ClientBsc,
    11155111: web3ClientSep,
    1: web3Client,
    137: polWeb3Client,
    8453: baseWeb3Client,
    10321: taoWeb3Client,
    97: web3ClientBscTest
}


export const apiUrl = 'https://api.flazepad.xyz';

export const imageUrl = apiUrl + '/token/'

export const projectName = "FlazePad"

export const zeroAddress = "0x0000000000000000000000000000000000000000"

// export const adminAddress = "0x11F538A35A6D33849534577ab2B2e8c6E261E88f";

export const BASE_URL = 'https://flazepad.xyz';

export const ethPriceApiUrl = {
    1: 'https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd',
    56: 'https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd',
    11155111: 'https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd',
    8453: 'https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd',
    137: 'https://api.coingecko.com/api/v3/simple/price?ids=matic-network&vs_currencies=usd',
    10321: 'https://api.coingecko.com/api/v3/simple/price?ids=bittensor&vs_currencies=usd',
    97: 'https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd'
}

// export const supportedChainIds = [mainnet.id, bsc.id, base.id, 10321]
export const supportedChainIds = [56, 11155111, 8453, 137, 10321, 97]

export const chainLogos = {
    1: '/eth.svg',
    56: '/bsc.svg',
    11155111: '/eth.svg',
    137: '/polygon.svg',
    8453: '/base.svg',
    10321: '/tao.png',
    97: '/bsc.svg',
}

export const feeAmounts = {
    1: 0,
    8453: 0,
    56: 0.005,
    137: 7.13,
    11155111: 0,
    10321: 0.0012,
    97: 0.001,
}

export const initialEth1 = {
    1: 1.5698,
    8453: 1.5698,
    56: 8.48,
    137: 12558,
    11155111: 1.9,
    10321: 1.9,
    97: 8.53125
}

export const initialEth2 = {
    1: 1.5698,
    8453: 1.5698,
    56: 8.48,
    137: 12558,
    11155111: 1.9,
    10321: 1.9,
    97: 6.2039
}

export const coinNames = {
    1: 'ETH',
    8453: 'ETH',
    56: 'BNB',
    11155111: 'ETH',
    10: 'ETH',
    137: 'POL',
    10321: 'TAO',
    97: 'BNB'
}

export const scanLinks = {
    8453: 'https://basescan.org/',
    1: 'https://etherscan.io/',
    56: 'https://bscscan.com/',
    11155111: 'https://sepolia.etherscan.io/',
    137: 'https://polygonscan.com/',
    10: 'https://optimistic.etherscan.io/',
    10321: 'https://taoscan.org/',
    97: 'https://testnet.bscscan.com/',
}

export const scanApiLinks = {
    8453: 'https://api.basescan.org/api',
    1: 'https://api.etherscan.io/api',
    56: 'https://api.bscscan.com/api',
    11155111: 'https://api-sepolia.etherscan.io/api',
    137: 'https://api.polygonscan.com/api',
    10321: 'https://taoscan.org/api',
    97: 'https://api-testnet.bscscan.com/api'
}

export const apiKeys = {
    56: 'Y7TXAF2H8KCPY7AXFT7DSTBFUVH794ZCST',
    1: '2E446YFS6EPUCJQ84W6GHX626759K121NP',
    11155111: '2E446YFS6EPUCJQ84W6GHX626759K121NP',
    8453: '26VQ3BGAUVDCN9VCNP7PZNG47I8X3S82F2',
    97: 'Y7TXAF2H8KCPY7AXFT7DSTBFUVH794ZCST',
}

export const chainNames = {
    1: 'eth',
    11155111: 'eth',
    8453: 'base',
    56: 'bnb',
    137: 'polygon',
    10321: 'tao',
    97: 'bnb',
}

export const chainNames1 = {
    1: 'ethereum',
    11155111: 'ethereum',
    8453: 'base',
    56: 'bsc',
    137: 'polygon',
    10321: 'tao',
    97: 'bscTestnet',
}

export default function formatNumber(number: number) {
    if (number >= 1000000) {
        return (number / 1000000).toLocaleString() + 'M';
    } else if (number >= 1000) {
        return (number / 1000).toLocaleString() + 'K';
    } else {
        return number.toString();
    }
}